module.exports = __webpack_public_path__ + "static/media/uc_san_diego_logo.b24ca042.png";